<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import RSliderComponent from '~/components/RSliderComponent.vue'
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Sliders/L Text R Slider2'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="py-10 px-xl xl:pl-2xl flex flex-col xl:grid grid-cols-12 gap-8 xl:gap-16"
    >
      <div class="flex flex-col gap-10 col-span-5">
        <div class="px-3 py-5 border-b-5 border-Tertiary w-fit">
          <span class="text-H2 text-Tekst">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
            />
          </span>
        </div>
        <span class="text-H4 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>
        <div class="flex flex-row gap-5 items-center">
          <CmsImage
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'image_1']"
            class="w-12 h-12"
          />
          <span class="text-H4 text-Tekst font-semibold py-1.5 border-b border-Tertiary">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_3']"
            />
          </span>
        </div>
        <span class="text-H4 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_4']"
          />
        </span>
        <div class="hidden xl:flex flex-col">
          <span class="text-Tekst"><CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_5']" /></span>
          <span class="text-H4 font-semibold text-Tekst no-underline"><CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_6']" /></span>
        </div>
        <CmsLink
          v-slot="{ link }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_1']"
        >
          <AppButton
            :href="link?.href"
            button-theme="Primary"
            class="xl:hidden flex"
            :target="link?.target"
          >
            <div class="flex flex-col xl:flex-row gap-2 items-center">
              <span class="link-text">{{ link?.link_text }}</span>
            </div>
          </AppButton>
        </CmsLink>
      </div>
      <CmsCustomComponentList
        v-slot="{ component_values: componentListValues }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'list']"
        :open-options="true"
        component-name="images_list"
        class="min-w-5 min-h-5 xl:pt-24 xl:col-span-7"
      >
        <RSliderComponent
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data']"
          :data-length="componentListValues.length"
          :data="componentListValues"
        />
      </CmsCustomComponentList>
    </div>
  </CmsCustomComponent>
</template>
